export default __webpack_public_path__ + "static/media/flag-turkey-inactive.dfae9fb7.svg";